import MuiTab from "@material-ui/core/Tab";
import MuiTabs from "@material-ui/core/Tabs";
import { t } from "i18next";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useTabsStyles = makeThemedStyles("ToolbarTabs", (theme) => ({
  root: {
    borderRadius: "26px",
    backgroundColor: "rgba(255,255,255,.2)",
    display: "inline-flex",
    minHeight: "32px",
    backdropFilter: "blur(4px) brightness(98%)",
    boxShadow: "inset 0 0 2px rgba(255,255,255,0.5)",
    opacity: 0.95,
  },
  indicator: {
    borderRadius: "26px",
    height: "100%",
    backgroundColor: "rgba(14, 156, 240, 1)",
  },
}));
const useTabStyles = makeThemedStyles("ToolbarTab", (theme) => ({
  root: {
    minWidth: "80px !important",
    minHeight: "30px",
    fontSize: "1.57em",
    marginTop: "2px",
    fontWeight: 600,
    textTransform: "unset",
    letterSpacing: "0.03em",
    lineHeight: "unset",
    color: "#fff",
  },
  selected: {
    zIndex: 1,
    color: "#fff",
  },
}));

type TabOption = { viewName: string; title?: string; icon?: JSX.Element };

const Tabs = (props: {
  options: TabOption[];
  selected?: string;
  tabsStyles?: typeof useTabsStyles;
  tabStyles?: typeof useTabStyles;
  onChange: (value: string) => void;
}) => {
  const tabsClasses = useTabsStyles();
  const tabClasses = useTabStyles();
  const [value, setValue] = React.useState(props.selected || "");

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    if (!newValue || newValue === value) return;
    setTimeout(() => {
      if (props.onChange) {
        props.onChange(newValue);
      }
      /**
       * GODO: navigate
       */
    }, 200);
  };

  React.useEffect(() => {
    setValue(props.selected || "");
  }, [props.selected]);

  return (
    <div>
      <MuiTabs classes={tabsClasses} value={value} onChange={handleChange}>
        {props.options.map((opt) => {
          return (
            <MuiTab
              key={opt.viewName}
              disableRipple
              icon={opt.icon}
              classes={tabClasses}
              value={opt.viewName}
              label={opt.title ? t(opt.title) : undefined}
            />
          );
        })}
      </MuiTabs>
    </div>
  );
};

export default Tabs;
